<template>
  <div>
    <mobialis-form-with-validation @onValidate="continueForm">
      <div>
        <div class="mb-3">
          <h3 class="mt-0">{{ $t('message.advancedFinance.personalDetailsQuestion.heading') }}</h3>
          <p>{{ $t('message.advancedFinance.personalDetailsQuestion.subheading') }}</p>
        </div>

        <div class="row">
          <div class="col-sm-2">
            <mobialis-selection-input-with-validation
              rules="required"
              :options="salutationOptions"
              v-model="salutation"
              :label="$t('message.advancedFinance.personalDetailsQuestion.salutation')"
            ></mobialis-selection-input-with-validation>
          </div>
          <div class="col">
            <mobialis-text-input-with-validation
              :rules="{ required: true, regex: /^([^0-9]*)$/ }"
              :label="$t('message.common.firstName')"
              v-model="firstName"
              vid="firstName"
              data-cy="firstName"
            ></mobialis-text-input-with-validation>
          </div>
        </div>

        <mobialis-text-input-with-validation
          :rules="{ required: true, regex: /^([^0-9]*)$/ }"
          :label="$t('message.common.lastName')"
          v-model="lastName"
          vid="lastName"
          data-cy="lastName"
        ></mobialis-text-input-with-validation>

        <div class="row">
          <div class="col-sm-3">
            <mobialis-text-input-with-validation
              :rules="birthDateValidationRule"
              :label="$t('message.advancedFinance.personalDetailsQuestion.dateOfBirth')"
              v-model="birthdate"
              :helper="$t('message.credit.birthdayHelper')"
              vid="birthdate"
              mask-type="date"
              :raw="false"
              inputmode="numeric"
              data-cy="birthdate"
            >
            </mobialis-text-input-with-validation>
          </div>
        </div>

        <div class="row">
          <div class="col-sm-5">
            <mobialis-text-input-with-validation
              rules="required|length:10"
              :label="$t('message.advancedFinance.personalDetailsQuestion.mobileNumber')"
              v-model="phoneNumber"
              vid="phoneNumber"
              placeholder="(   )"
              mask-type="phoneNumber"
              type="tel"
              data-cy="phoneNumber"
            ></mobialis-text-input-with-validation>
          </div>
          <div class="col-md-4 col-sm-5">
            <mobialis-text-input-with-validation
              rules="length:10"
              :label="$t('message.advancedFinance.personalDetailsQuestion.homeNumber')"
              v-model="homePhoneNumber"
              vid="homePhoneNumber"
              placeholder="(   )"
              mask-type="phoneNumber"
              type="tel"
              data-cy="homePhoneNumber"
            ></mobialis-text-input-with-validation>
          </div>
        </div>

        <mobialis-text-input-with-validation
          rules="required|email"
          :label="$t('message.common.emailAddress')"
          v-model="emailAddress"
          vid="emailAddress"
          data-cy="emailAddress"
          type="email"
        ></mobialis-text-input-with-validation>
      </div>
      <mobialis-button data-cy="submit" type="submit" class="mt-4 mb-1">{{
        $t('message.common.continue')
      }}</mobialis-button>
    </mobialis-form-with-validation>
  </div>
</template>

<script>
import cloneDeep from 'lodash/fp/cloneDeep';
import { Salutations } from '@/utils/enums';
import { formMixin } from '@/mixins';

export default {
  name: 'PersonalDetailsQuestion',
  mixins: [formMixin],
  data() {
    return {
      salutation: cloneDeep(this.$store.state.user.salutation),
      firstName: cloneDeep(this.$store.state.user.firstName),
      lastName: cloneDeep(this.$store.state.user.lastName),
      birthdate: cloneDeep(this.$store.state.user.birthdate),
      phoneNumber: cloneDeep(this.$store.state.user.phoneNumber),
      homePhoneNumber: cloneDeep(this.$store.state.user.homePhoneNumber),
      emailAddress: cloneDeep(this.$store.state.user.emailAddress),
      salutationOptions: [
        {
          label: this.$t('message.advancedFinance.personalDetailsQuestion.salutationOptions.dr'),
          value: Salutations.DR,
        },
        {
          label: this.$t('message.advancedFinance.personalDetailsQuestion.salutationOptions.mr'),
          value: Salutations.MR,
        },
        {
          label: this.$t('message.advancedFinance.personalDetailsQuestion.salutationOptions.mrs'),
          value: Salutations.MRS,
        },
        {
          label: this.$t('message.advancedFinance.personalDetailsQuestion.salutationOptions.ms'),
          value: Salutations.MS,
        },
        {
          label: this.$t('message.advancedFinance.personalDetailsQuestion.salutationOptions.miss'),
          value: Salutations.MIS,
        },
      ],
    };
  },
  components: {},
  methods: {
    async continueForm(isValid) {
      if (!isValid) {
        return;
      }
      this.$store.commit('user/SET_SALUTATION', this.salutation);
      this.$store.commit('user/SET_FIRST_NAME', this.firstName);
      this.$store.commit('user/SET_LAST_NAME', this.lastName);
      this.$store.commit('user/SET_BIRTHDATE', this.birthdate);
      this.$store.commit('user/SET_PHONE_NUMBER', this.phoneNumber);
      this.$store.commit('user/SET_HOME_PHONE_NUMBER', this.homePhoneNumber);
      this.$store.commit('user/SET_EMAIL_ADDRESS', this.emailAddress);
      this.$router.push({ path: this.getNextRoutePath() });
    },
  },
};
</script>

<style lang="scss" scoped></style>
